import { useTranslation } from 'react-i18next';

import {
  DatePickerInput,
  Form,
  NumberInput,
  PLATFORM_THEME_COLORS,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import {
  EmployeeNoticePeriodTypesEnum,
  EmployeeTerminatedTypesEnum,
  EmployeeReferencePeriodEnum,
} from '@thinknet-gmbh/platform-common';

import { TitleRowLabel, StyledContainer, StyledRowContainer } from '../../employee-common.styles';
import { GeneralConditionRowContainer } from '../working-conditions.styles';

const CancelInformation = () => {
  const { t, i18n } = useTranslation(['common', 'employee', 'settings']);

  return (
    <StyledContainer>
      <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('employee:workingConditions.labels.workingAndVacation')}
      </TitleRowLabel>
      <GeneralConditionRowContainer>
        <Form.Item
          name={'noticePeriod'}
          rules={[
            {
              required: true,
              message: t('common:validation.error.fieldRequired'),
            },
          ]}
          label={t('employee:labels.noticePeriod')}
        >
          <NumberInput
            className={'suffix-selector-input'}
            placeholder={90}
            maxLength={9}
            addonAfter={
              <Form.Item
                name="noticePeriodType"
                noStyle
                rules={[
                  {
                    required: true,
                    message: t('common:validation.error.fieldRequired'),
                  },
                ]}
              >
                <SelectInput className={'suffix-selector'} style={{ width: 140 }}>
                  {Object.keys(EmployeeNoticePeriodTypesEnum).map(type => {
                    return (
                      <SelectInput.Option key={type} value={type}>
                        {t(
                          `employee:workingConditions.labels.probationTypes.${type.toLowerCase()}`
                        )}
                      </SelectInput.Option>
                    );
                  })}
                </SelectInput>
              </Form.Item>
            }
          />
        </Form.Item>
        <Form.Item
          name="referencePeriod"
          label={t('employee:workingConditions.labels.referencePeriod')}
          rules={[
            {
              required: true,
              message: t('common:validation.error.fieldRequired'),
            },
          ]}
        >
          <SelectInput>
            placeholder={t('common:placeholders.selectFromList')}
            {Object.keys(EmployeeReferencePeriodEnum).map(type => {
              return (
                <SelectInput.Option key={type} value={type}>
                  {t(
                    `employee:workingConditions.labels.referencePeriodOptions.${type.toLowerCase()}`
                  )}
                </SelectInput.Option>
              );
            })}
          </SelectInput>
        </Form.Item>
      </GeneralConditionRowContainer>
      <StyledRowContainer>
        <Form.Item name={'terminationDate'} label={t('employee:labels.terminationDate')}>
          <DatePickerInput inputReadOnly={true} lang={i18n.language} format="DD.MM.YYYY" />
        </Form.Item>

        <Form.Item name="terminatedBy" label={t('employee:workingConditions.labels.terminatedBy')}>
          <SelectInput>
            placeholder={t('common:placeholders.selectFromList')}
            {Object.keys(EmployeeTerminatedTypesEnum).map(type => {
              return (
                <SelectInput.Option key={type} value={type}>
                  {t(`employee:workingConditions.labels.terminatedTypes.${type.toLowerCase()}`)}
                </SelectInput.Option>
              );
            })}
          </SelectInput>
        </Form.Item>

        <Form.Item name={'contractExpirationDate'} label={t('employee:labels.contractEnds')}>
          <DatePickerInput inputReadOnly={true} lang={i18n.language} format="DD.MM.YYYY" />
        </Form.Item>
      </StyledRowContainer>
    </StyledContainer>
  );
};

export default CancelInformation;
